import React, { useState } from 'react';
import localization from 'assets/localization/localization';
import DatePicker from 'components/sales/datePicker/datePicker';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from '../Input/dropDownInput/dropDownInput';

const CommissionPayoutFilter = ({
  applyFilter,
}) => {
  const filterInputs = {
    status: '',
    logged_in_start_date: '',
    logged_in_end_date: '',
    disbursal_start_date: '',
    disbursal_end_date: ''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <DatePicker
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, disbursal_start_date: val })
        }}
        label={localization.disbursalStartDate}
        required={false}
        value={window.localStorage?.commission_payout_filter && window.localStorage?.commission_payout_filter ? JSON.parse(window.localStorage?.commission_payout_filter)['disbursal_start_date'] : ""}
      />
      <DatePicker
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, disbursal_end_date: val })
        }}
        label={localization.disbursalEndDate}
        required={false}
        value={window.localStorage?.commission_payout_filter && window.localStorage?.commission_payout_filter ? JSON.parse(window.localStorage?.commission_payout_filter)['disbursal_end_date'] : ""}
      />
      <DropDownInput
        label="Status"
        data={[
          {
            id: "LOGGED_IN",
            name: "LOGGED_IN",
          },
          {
            id: "REQUEST_FOR_CASE_APPROVAL",
            name: "REQUEST_FOR_CASE_APPROVAL",
          },
          {
            id: "COMPLETE_PAYMENT_RELEASED",
            name: "COMPLETE_PAYMENT_RELEASED",
          },
          {
            id: "PARTIAL_PAYMENT_RELEASED",
            name: "PARTIAL_PAYMENT_RELEASED",
          }
        ]}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, status: val?.id });
        }}
        value={window.localStorage?.commission_payout_filter && window.localStorage?.commission_payout_filter ? JSON.parse(window.localStorage?.commission_payout_filter)['status'] : ""}
      />
      <DatePicker
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, logged_in_start_date: val })
        }}
        label={localization.loggedInStartDate}
        required={false}
        value={window.localStorage?.commission_payout_filter && window.localStorage?.commission_payout_filter ? JSON.parse(window.localStorage?.commission_payout_filter)['logged_in_start_date'] : ""}
      />
      <DatePicker
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, logged_in_end_date: val })
        }}
        label={localization.loggedInEndDate}
        required={false}
        value={window.localStorage?.commission_payout_filter && window.localStorage?.commission_payout_filter ? JSON.parse(window.localStorage?.commission_payout_filter)['logged_in_end_date'] : ""}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default CommissionPayoutFilter;

